module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/loader-fallback-f418d21439fa417948826d35a85528a5.png";